<template >
  <!-- /https://vuetifyjs.com/en/components/text-fields/ -->
  <v-text-field
    @keypress="filter(event)"
    type="number"
    :label="formDetail.title"
    v-model="iValue"
    :name="index"
    :rules="[rulesForm.required, rulesForm.min, rulesForm.max]"
  >
  <template v-slot:append-inner>
      <v-tooltip location="bottom" v-if="formDetail.description">
        <template v-slot:activator="{ props }">
          <v-icon v-bind="props" icon="mdi-help-circle-outline"></v-icon>
        </template>
        {{ formDetail.description }}
      </v-tooltip>
    </template>
  </v-text-field>
</template>
 
<script setup>
const props = defineProps({
  formDetail: {
    type: Object,
    required: true,
  },
  model: {
    type: Object,
    required: true,
  },
  index: {
    type: String,
    required: false,
  },
});
function filter(evt) {
  evt = evt ? evt : window.event;
  let expect = evt.target.value.toString() + evt.key.toString();
  var pattern = /^\d+$/;

  if (!pattern.test(expect)) {
    evt.preventDefault();
  } else {
    return true;
  }
}
const { $form} = useNuxtApp()
const rulesForm = $form.getRules(props.formDetail,props.index);

let iValue = ref(props.model[props.index] ? props.model[props.index] : "");
</script>